var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BigNumber } from 'ethers';
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctAddressList, FctBoolean, FctBytes32, FctValue, isVariable } from '../../../../Fct/generics';
import { getAllCurrencies } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { ROUTER_V2_ADDRESS } from '../../../../Fct/plugins/uniswap/constants';
import { getMethodName } from '../../../../Fct/plugins/uniswap/helpers/getMethodName';
import { getIsNative } from '../../../../Fct/plugins/uniswap/helpers/getToken';
import { WETH9 } from '@uniswap/sdk-core';
import { fctUniswapContracts, method } from '../constants';
export var SwapNoSlippageProtection = createPlugin({
    protocol: 'UNISWAP',
    type: 'LIBRARY',
    method: 'swap_noSlippageProtection',
    supportedContracts: fctUniswapContracts,
    toEns: '@lib:uniswap_v2',
    initParams: {
        isExactIn: 'true',
        snipperMode: 'false',
    },
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                addressIn: new FctAddress({
                    destination: 'erc20',
                    mode: 'INPUT',
                    options: getAllCurrencies({ chainId: chainId }),
                }),
                amountIn: new FctValue({
                    destination: 'wei_amount',
                }),
                addressOut: new FctAddress({
                    destination: 'erc20',
                    mode: 'INPUT',
                    options: getAllCurrencies({ chainId: chainId }),
                }),
                amountOut: new FctValue({
                    destination: 'wei_amount',
                }),
                isExactIn: new FctBoolean({}),
                snipperMode: new FctBoolean({}),
                methodParams: {
                    amount: new FctValue({ destination: 'wei_amount', readonly: true }),
                    method: new FctBytes32({
                        messageType: 'string',
                        options: Object.keys(method).map(function (key) {
                            var methodKey = key;
                            return { name: key, value: method[methodKey] };
                        }),
                    }),
                    path: new FctAddressList({ destination: 'ERC20_List' }),
                },
            },
            output: {
                amountIn: new FctValue({ innerIndex: 0, destination: 'wei_amount' }),
                amountOut: new FctValue({ innerIndex: 1, destination: 'wei_amount' }),
            },
        });
    },
    overrideSetMethodParams: function (_a) {
        var input = _a.input;
        return function (params) {
            Object.keys(input.methodParams).forEach(function (key, i) {
                var paramKey = key;
                input.methodParams[paramKey].value = params[i];
            });
            var isExactIn = input.isExactIn.value === 'true';
            if (isExactIn) {
                input.amountIn.value = input.methodParams.amount.value;
            }
            else {
                input.amountOut.value = input.methodParams.amount.value;
            }
        };
    },
    calculateValuesOnUserInput: function (_a) {
        var input = _a.input, output = _a.output, chainId = _a.chainId;
        var getPathParams = function (_a) {
            var service = _a.service;
            return __awaiter(void 0, void 0, void 0, function () {
                var isSnipperMode, isExactIn, uniswapService, tokenInAddress, tokenOutAddress, defaultReturn, decimalsIn, decimalsOut, amountIn, amountOut, getAmount, amount, methodName, methodParamValue, path, isSimulationNeeded, res, swapPath, methodName, methodParamValue, e_1;
                var _b, _c, _d, _e;
                return __generator(this, function (_f) {
                    switch (_f.label) {
                        case 0:
                            if (!service)
                                return [2 /*return*/];
                            isSnipperMode = input.snipperMode.value === 'true';
                            isExactIn = input.isExactIn.value === 'true';
                            uniswapService = service;
                            tokenInAddress = input.addressIn.value;
                            tokenOutAddress = input.addressOut.value;
                            if (isExactIn) {
                                input.amountIn.readonly = false;
                                input.amountOut.readonly = true;
                            }
                            if (!isExactIn) {
                                input.amountIn.readonly = true;
                                input.amountOut.readonly = false;
                            }
                            defaultReturn = isExactIn
                                ? {
                                    params: {
                                        amountOut: undefined,
                                        methodParams: { path: undefined, method: undefined, amount: undefined },
                                    },
                                    error: undefined,
                                }
                                : {
                                    params: {
                                        amountIn: undefined,
                                        methodParams: { path: undefined, method: undefined, amount: undefined },
                                    },
                                    error: undefined,
                                };
                            if (!tokenInAddress ||
                                !tokenOutAddress ||
                                typeof tokenInAddress !== 'string' ||
                                typeof tokenOutAddress !== 'string') {
                                return [2 /*return*/, defaultReturn];
                            }
                            decimalsIn = ((_b = input.amountIn) === null || _b === void 0 ? void 0 : _b.decimals) !== undefined ? (_c = input.amountIn) === null || _c === void 0 ? void 0 : _c.decimals : 18;
                            decimalsOut = ((_d = input.amountOut) === null || _d === void 0 ? void 0 : _d.decimals) !== undefined ? (_e = input.amountOut) === null || _e === void 0 ? void 0 : _e.decimals : 18;
                            amountIn = output.amountIn, amountOut = output.amountOut;
                            amountIn.decimals = decimalsIn;
                            amountOut.decimals = decimalsOut;
                            getAmount = function () {
                                if (isExactIn) {
                                    if (isVariable(input.amountIn.value) &&
                                        input.amountIn.estimatedValue &&
                                        input.amountIn.estimatedValue !== '0') {
                                        return input.amountIn.estimatedValue;
                                    }
                                    return input.amountIn.value;
                                }
                                if (isVariable(input.amountOut.value) &&
                                    input.amountOut.estimatedValue &&
                                    input.amountOut.estimatedValue !== '0') {
                                    return input.amountOut.estimatedValue;
                                }
                                return input.amountOut.value;
                            };
                            amount = getAmount();
                            if (amount === undefined)
                                return [2 /*return*/, defaultReturn];
                            if (isSnipperMode) {
                                methodName = getMethodName({
                                    isExactInput: isExactIn,
                                    protocol: 'V2',
                                    isInputNative: getIsNative(tokenInAddress),
                                    isOutputNative: getIsNative(tokenOutAddress),
                                });
                                methodParamValue = method[methodName];
                                path = [tokenInAddress, tokenOutAddress].map(function (tokenAddress) {
                                    if (getIsNative(tokenAddress))
                                        return WETH9[Number(chainId)].address;
                                    return tokenAddress;
                                });
                                if (isExactIn) {
                                    return [2 /*return*/, {
                                            params: {
                                                amountOut: '0',
                                                methodParams: { path: path, method: methodParamValue, amount: isVariable(input.amountIn.value) ? input.amountIn.value : amount },
                                            },
                                            isSimulationNeeded: false,
                                            error: undefined,
                                        }];
                                }
                                return [2 /*return*/, {
                                        params: {
                                            amountIn: '0',
                                            methodParams: { path: path, method: methodParamValue, amount: isVariable(input.amountOut.value) ? input.amountOut.value : amount },
                                        },
                                        isSimulationNeeded: false,
                                        error: undefined,
                                    }];
                            }
                            isSimulationNeeded = false;
                            if (!amount || isVariable(amount)) {
                                isSimulationNeeded = true;
                                amount = '1' + '0'.repeat(isExactIn ? decimalsIn : decimalsOut);
                            }
                            _f.label = 1;
                        case 1:
                            _f.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, uniswapService.create({
                                    cmd: 'simulateSwap',
                                    protocol: 'uniswap',
                                    token_in: tokenInAddress,
                                    token_in_decimals: decimalsIn,
                                    token_out: tokenOutAddress,
                                    token_out_decimals: decimalsOut,
                                    token_amount: amount,
                                    version: 'v2',
                                    type: isExactIn ? 'in' : 'out',
                                })];
                        case 2:
                            res = (_f.sent());
                            swapPath = res === null || res === void 0 ? void 0 : res.path;
                            if (!swapPath) {
                                return [2 /*return*/, {
                                        params: {
                                            amountIn: isExactIn ? amount : undefined,
                                            amountOut: isExactIn ? undefined : amount,
                                            methodParams: { path: undefined, amount: undefined, method: undefined },
                                        },
                                        error: 'invalid trade',
                                    }];
                            }
                            methodName = getMethodName({
                                isExactInput: isExactIn,
                                protocol: 'V2',
                                isInputNative: getIsNative(tokenInAddress),
                                isOutputNative: getIsNative(tokenOutAddress),
                            });
                            methodParamValue = method[methodName];
                            if (isExactIn) {
                                return [2 /*return*/, {
                                        params: {
                                            amountOut: res.outputAmount,
                                            methodParams: {
                                                path: swapPath,
                                                method: methodParamValue,
                                                amount: isVariable(input.amountIn.value) ? input.amountIn.value : amount,
                                            },
                                        },
                                        isSimulationNeeded: isSimulationNeeded,
                                        error: undefined,
                                    }];
                            }
                            return [2 /*return*/, {
                                    params: {
                                        amountIn: res.inputAmount,
                                        methodParams: {
                                            path: swapPath,
                                            method: methodParamValue,
                                            amount: isVariable(input.amountOut.value) ? input.amountOut.value : amount,
                                        },
                                    },
                                    isSimulationNeeded: isSimulationNeeded,
                                    error: undefined,
                                }];
                        case 3:
                            e_1 = _f.sent();
                            return [2 /*return*/, {
                                    params: {
                                        amountIn: isExactIn ? amount : undefined,
                                        amountOut: isExactIn ? undefined : amount,
                                        methodParams: { path: undefined, amount: undefined, method: undefined },
                                    },
                                    error: e_1.message,
                                }];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        var getDepParams = function () {
            var isExactIn = input.isExactIn.value === 'true';
            return isExactIn
                ? ['addressIn', 'addressOut', 'isExactIn', 'snipperMode', 'amountIn']
                : ['addressIn', 'addressOut', 'isExactIn', 'snipperMode', 'amountOut'];
        };
        return {
            get: getPathParams,
            depParamKeys: getDepParams,
        };
    },
    requiredApprovals: function (params, chainId, _walletAddress, _vaultAddress, _provider, _method, isEstimation) {
        var _a;
        var _b = params.methodParams, amount = _b.amount, path = _b.path;
        if (params.methodParams.method.value === method.swapExactETHForTokens ||
            params.methodParams.method.value === method.swapETHForExactTokens) {
            return [];
        }
        var getAmount = function () {
            if (isEstimation) {
                if (isVariable(params.amountIn.value)) {
                    return (params.amountIn.estimatedValue || amount.estimatedValue);
                }
            }
            return (params.amountIn.value || amount.value);
        };
        return [
            {
                to: params.addressIn.value ? params.addressIn.value : (_a = path.value) === null || _a === void 0 ? void 0 : _a[0],
                params: { spender: ROUTER_V2_ADDRESS[chainId], amount: getAmount() },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
    onCreate: function (_a) {
        var input = _a.input;
        var setAmountIn = function () {
            if (input.isExactIn.value !== 'true')
                return;
            input.methodParams.amount.set({ value: input.amountIn.value });
            input.methodParams.amount.setEstimated({ value: input.amountIn.estimatedValue });
        };
        var setAmountOut = function () {
            if (input.isExactIn.value === 'true')
                return;
            input.methodParams.amount.set({ value: input.amountOut.value });
            input.methodParams.amount.setEstimated({ value: input.amountOut.estimatedValue });
        };
        input.amountIn.subscribe({
            callback: function () {
                setAmountIn();
            },
            id: 'set amount by amountIn',
        });
        input.amountOut.subscribe({
            callback: function () {
                setAmountOut();
            },
            id: 'set amount by amountOut',
        });
        input.isExactIn.subscribe({
            callback: function (_a) {
                var value = _a.value;
                if (value === 'true') {
                    setAmountIn();
                }
                if (value === 'false') {
                    setAmountOut();
                }
            },
            id: 'set amount on isExactIn change',
        });
        setAmountIn();
        setAmountOut();
    },
    estimateGasOnParams: function (params, method, chainId) {
        // base gas 140000
        // 80000 gas for every additional token in the path after 2
        var baseGas = BigNumber.from('140000');
        var path = params.methodParams.path;
        if (!path.value || !path.value.length) {
            return chainId === '42161' ? baseGas.mul(13).toString() : baseGas.toString();
        }
        var gasPerToken = BigNumber.from('80000');
        var gas = baseGas.add(gasPerToken.mul(path.value.length - 2));
        if (chainId === '42161') {
            gas = gas.mul(13);
        }
        return gas.toString();
    },
});
